import React, { useState, useEffect } from 'react';

export const useImageFallback = (
  originalUrl?: string,
  fallbackUrl?: string
) => {
  const [imageSrc, setImageSrc] = useState<string | undefined>(originalUrl);
  const [isFallbackUsed, setIsFallbackUsed] = useState<boolean>(false);

  const handleError = (_: React.SyntheticEvent<HTMLImageElement, Event>) => {
    if (fallbackUrl && !isFallbackUsed) {
      setImageSrc(fallbackUrl);
      setIsFallbackUsed(true);
    } else {
      setImageSrc(undefined);
      setIsFallbackUsed(true);
    }
  };

  useEffect(() => {
    setImageSrc(originalUrl);
    setIsFallbackUsed(false);
  }, [originalUrl, fallbackUrl]);

  return { imageSrc, handleError, isFallbackUsed };
};
